module.exports = __webpack_public_path__ + "img/logo.3f40ccd2.png";